import { render, staticRenderFns } from "./publicIframe.vue?vue&type=template&id=b4e50f24"
import script from "./publicIframe.vue?vue&type=script&lang=js"
export * from "./publicIframe.vue?vue&type=script&lang=js"
import style0 from "./publicIframe.vue?vue&type=style&index=0&id=b4e50f24&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports